import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import localforage from "localforage";
import SideBar from "./SideBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faCalendarCheck,
  faCalendarDay,
  faCalendarDays,
  faCalendarPlus,
  faFileContract,
} from "@fortawesome/free-solid-svg-icons";

const LeaveSection = () => {
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      const name = await localforage.getItem("userName");
      const userEmail = await localforage.getItem("email");
      const userRole = await localforage.getItem("role");

      if (name) setUserName(name);
      if (userEmail) setEmail(userEmail);
      if (userRole) setRole(userRole);
    };

    fetchUserData();
  }, []);

  const QuickAccessCard = ({ to, icon, title, description }) => (
    <div className="card quick-access-card" onClick={() => navigate(to)} style={{ cursor: "pointer" }}>
      <div className="d-flex align-items-center mb-3">
        <div className="stat-card-icon">
          <FontAwesomeIcon icon={icon} />
        </div>
      </div>
      <h3 className="card-title" style={{ fontSize: "1.25rem", marginBottom: "8px" }}>{title}</h3>
      <p style={{ color: "var(--text-gray)", fontSize: "0.9rem", marginBottom: 0 }}>{description}</p>
    </div>
  );

  const adminEmails = [
    "shreyas.uttekar@showtimeconsulting.in",
    "saumitra@showtimeconsulting.in",
    "anuragsaxena@showtimeconsulting.in",
    "at@showtimeconsulting.in"
  ];

  const isAdmin = role === "hr" || adminEmails.includes(email);

  return (
    <>
      <SideBar />
      <div className="dashboard-container">
        <div className="dashboard-header">
          <h1 className="dashboard-title">Leave Management</h1>
          <p className="dashboard-subtitle">Welcome, {userName}! Manage your leave requests here.</p>
        </div>

        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Quick Access</h2>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-4">
                <QuickAccessCard
                  to="/leave-data"
                  icon={faCalendarDay}
                  title="Check Leave Status"
                  description="View your leave request history"
                />
              </div>
              <div className="col-4">
                <QuickAccessCard
                  to="/leave-form"
                  icon={faCalendarPlus}
                  title="Request Leave"
                  description="Submit a new leave application"
                />
              </div>
              <div className="col-4">
                <QuickAccessCard
                  to="/maha-holiday-calendar"
                  icon={faCalendarAlt}
                  title="Holiday Calendar"
                  description="View upcoming holidays"
                />
              </div>
              <div className="col-4">
                <QuickAccessCard
                  to="/leave-data-rm"
                  icon={faCalendarCheck}
                  title="Leave Approvals"
                  description="Approve/reject leave requests"
                />
              </div>
              <div className="col-4">
                <div
                  className="card quick-access-card"
                  onClick={() =>
                    window.open(
                      "https://akar-portal-data.s3.ap-south-1.amazonaws.com/AKAR_Attendance_Leave_Policy+(1).pdf",
                      "_blank"
                    )
                  }
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center mb-3">
                    <div className="stat-card-icon">
                      <FontAwesomeIcon icon={faFileContract} />
                    </div>
                  </div>
                  <h3 className="card-title" style={{ fontSize: "1.25rem", marginBottom: "8px" }}>Leave Policy</h3>
                  <p style={{ color: "var(--text-gray)", fontSize: "0.9rem", marginBottom: 0 }}>View leave policy document</p>
                </div>
              </div>
              {/* {isAdmin && (
                <div className="col-4">
                  <QuickAccessCard
                    to="/leave-data-admin"
                    icon={faCalendarDays}
                    title="Admin Leave Data"
                    description="View all employee leaves"
                  />
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaveSection;
